/* ============================================
   Cookie Consent JS, Mark Ryden Wholesale

   Consent only. The price list and 10% off popups that used to
   live in this file have been removed: they fired on a blind
   8 second setTimeout with no consent check, which is why they
   landed on top of the consent bar and the newsletter popup.
   Those offers are now overlay-group sections, sequenced by
   mrw-overlay-queue.js.

   This bar is now the only consent UI on the store, so it also
   reports the visitor's choice to Shopify's Customer Privacy
   API. Without that call the bar would set its own cookie and
   nothing downstream would actually be gated: analytics and
   marketing pixels would keep firing after a refusal.
   ============================================ */

(function () {
  'use strict';

  var COOKIE_KEY = 'bls_cookie_consent';
  var privacyReady = false;

  // ---- Shopify Customer Privacy API ----
  function loadPrivacyApi(cb) {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        privacyReady = true;
        if (cb) cb();
      }
    );
  }

  function applyConsent(prefs) {
    if (!privacyReady || !window.Shopify || !window.Shopify.customerPrivacy) return;
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: !!prefs.analytics,
        marketing: !!prefs.marketing,
        preferences: !!prefs.analytics,
        sale_of_data: !!prefs.marketing
      }, function () {});
    } catch (e) {}
  }

  // ---- Helpers ----
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      try { return JSON.parse(decodeURIComponent(match[2])); } catch (e) { return null; }
    }
    return null;
  }

  function show(el) { if (el) el.style.display = ''; }
  function hide(el) { if (el) el.style.display = 'none'; }

  var cookieBar = document.getElementById('bls-cookie-bar');
  var cookieModal = document.getElementById('bls-cookie-modal');

  function save(prefs) {
    setCookie(COOKIE_KEY, prefs, 365);
    applyConsent(prefs);
    hide(cookieBar);
    hide(cookieModal);
  }

  function initCookieConsent() {
    var prefs = getCookie(COOKIE_KEY);
    if (!prefs) {
      show(cookieBar);
    } else {
      // returning visitor: replay their stored choice so the gate
      // survives the session, not just the click
      loadPrivacyApi(function () { applyConsent(prefs); });
      return;
    }
    loadPrivacyApi();
  }

  function acceptAll() { save({ necessary: true, analytics: true, marketing: true }); }
  function rejectAll() { save({ necessary: true, analytics: false, marketing: false }); }

  function savePrefs() {
    var analytics = document.getElementById('bls-pref-analytics');
    var marketing = document.getElementById('bls-pref-marketing');
    save({
      necessary: true,
      analytics: analytics ? analytics.checked : false,
      marketing: marketing ? marketing.checked : false
    });
  }

  function openCookieModal() {
    var prefs = getCookie(COOKIE_KEY);
    if (prefs) {
      var analytics = document.getElementById('bls-pref-analytics');
      var marketing = document.getElementById('bls-pref-marketing');
      if (analytics) analytics.checked = !!prefs.analytics;
      if (marketing) marketing.checked = !!prefs.marketing;
    }
    hide(cookieBar);
    show(cookieModal);
  }

  // Cookie bar buttons
  var btnBarReject = document.getElementById('bls-cookie-bar-reject');
  var btnBarManage = document.getElementById('bls-cookie-bar-manage');
  var btnBarAccept = document.getElementById('bls-cookie-bar-accept');
  if (btnBarReject) btnBarReject.addEventListener('click', rejectAll);
  if (btnBarManage) btnBarManage.addEventListener('click', openCookieModal);
  if (btnBarAccept) btnBarAccept.addEventListener('click', acceptAll);

  // Cookie modal buttons
  var btnModalClose = document.getElementById('bls-cookie-modal-close');
  var btnSave = document.getElementById('bls-cookie-save');
  var btnAcceptAll = document.getElementById('bls-cookie-accept-all');
  if (btnModalClose) btnModalClose.addEventListener('click', function () { hide(cookieModal); show(cookieBar); });
  if (btnSave) btnSave.addEventListener('click', savePrefs);
  if (btnAcceptAll) btnAcceptAll.addEventListener('click', acceptAll);

  // Click outside modal to close
  if (cookieModal) {
    cookieModal.addEventListener('click', function (e) {
      if (e.target === cookieModal) { hide(cookieModal); show(cookieBar); }
    });
  }

  // Let anything on the page reopen preferences, e.g. a footer link
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-open="cookie-preferences"]');
    if (el) { e.preventDefault(); openCookieModal(); }
  });

  initCookieConsent();
})();
